import styled, { css } from "styled-components";
import Text from "../Text";

export const Container = styled.div`
  display: flex;
  gap: 8px;
`;

export const TrackName = styled(Text)<{ maxWidth?: string }>`
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
